import { CONSTRUCTOR_FIELD_CONTAINER } from './CONSTRUCTOR_FIELD_CONTAINER';
import { DTO_META__field_info } from './DTO_META__field_info';
import { FIELD__base } from './FIELD__base';

export class REFLECT_METADATA<T_FIELD extends FIELD__base> {
  options_field!: Partial<T_FIELD>;
  options_meta!: Partial<DTO_META__field_info>;
  class_object!: CONSTRUCTOR_FIELD_CONTAINER<T_FIELD>;
}
